module.exports = __webpack_public_path__ + "static/media/SHVO.6c48a190.png";